export const HEADER_SEARCH_BAR_DONE = (state, payload) => ({
    type: 'UI',
    payload: {
        ui_headerSearchBar: {
            state: state,
            payload: payload
        }
    }
});

export const CATEGORY_SEARCH_RESULTS = (state, payload) => ({
    type: 'COMMON',
    payload: {
        categorySearchResults: {
            state: state,
            ...((typeof payload == 'object') ? payload : {})
        }
    }
});

export const UPDATE_VARIANTS = (state, variants) => ({
    type: 'COMMON',
    ...(Array.isArray(variants) ? {
        payload: {
            variants: {
                state: state,
                data: variants
            }
        }
    } : {})
});
export const UPDATE_FILTER = (state, filter) => ({
    type: 'COMMON',
    payload: {
        filter: {
            state: state,
            data: filter
        }
    }
});
export const UPDATE_BRANDS = (state, brands) => ({
    type: 'COMMON',
    payload: {
        brands: {
            state: state,
            data: brands
        }
    }
});
export const COLLECTION_FILTER = (payload) => ({
    type: 'COMMON',
    payload: {
        collectionFilter: payload || {}
    }
});